import { render } from "./PotionsView.vue?vue&type=template&id=b0325742&scoped=true"
import script from "./PotionsView.vue?vue&type=script&lang=js"
export * from "./PotionsView.vue?vue&type=script&lang=js"

import "./PotionsView.vue?vue&type=style&index=0&id=b0325742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0325742"]])

export default __exports__